<template>
  <div class="price-apply">

    <re-dialog :visible.sync="handle_goods_show" title="改价" width="700px">
      <el-form label-width="100px" style="width: 500px;margin: 0 auto" class="p20">
        <el-form-item label="规格:">
          <el-input v-model="current_goods.specification_name" readonly/>
        </el-form-item>
        <el-form-item v-for="i in goodsSpecificationInputList" :key="i.key" :label="`${i.label}：`">
          <template #label>
            <el-tooltip class="item" effect="dark" :content="enterALimit(i)" placement="top-start">
              <p>{{ i.label }}
                <i class="el-icon-question"></i>
                ：</p>
            </el-tooltip>
          </template>
          <el-input-number v-model="current_goods[i.key]" controls-position="right" :min="i.min" :max="i.max"/>
        </el-form-item>

        <el-form-item label="系统价格">
          <el-input placeholder="请输入内容" type="number" v-model="current_goods.goods_actual_price" readonly/>
        </el-form-item>
        <el-form-item label="可改最低价"
                      v-if="!is_Empty(current_goods.goods_min_price) && current_goods.goods_min_price > 0">
          <el-input placeholder="请输入内容" type="number" v-model="current_goods.goods_min_price" readonly/>
        </el-form-item>
        <el-form-item label="新价格">
          <el-input placeholder="请输入内容" @focus="is_disabled = true" @blur="is_disabled = false" type="number"
                    v-model="new_goods_actual_price"/>
        </el-form-item>
        <el-form-item label="总价跌幅：" v-show="decline !== 0">
          <span class="red">{{ decline }}%</span>
        </el-form-item>
        <el-form-item>
          <!-- 计算价格 -->
          <div class="computed-price-type1"
               style="display: grid;grid-template-columns: 30% 5% 30% 5% 30%;line-height: 40px;text-align: center;"
               v-show="orderGoodsSpecificationInputBeans.length === 2">
            <p>单价</p>
            <p></p>
            <p>面积</p>
            <p></p>
            <p>数量</p>
            <el-input v-model="good_unit_price" @focus="is_disabled = false" @blur="is_disabled = true"/>
            <span class="fz30">×</span>
            <el-input type="number" v-model="area" disabled/>
            <span class="fz30">×</span>
            <el-input type="number" v-model="goods_num"/>
          </div>
          <div class="computed-price-type2"
               style="display: grid;grid-template-columns: 45% 10% 45%;line-height: 40px;text-align: center;"
               v-show="orderGoodsSpecificationInputBeans.length !== 2">
            <p>单价</p>
            <p></p>
            <p>数量</p>
            <el-input type="number" @focus="is_disabled = false" @blur="is_disabled = true" v-model="good_unit_price"/>
            <span>×</span>
            <el-input type="number" v-model="goods_num"/>
          </div>
        </el-form-item>
      </el-form>
      <div class="fr ac jc" slot="footer">
        <el-button type="primary" size="small" @click="changeOrderGoodsPriceCheck">确认</el-button>
      </div>
    </re-dialog>
  </div>
</template>

<script>
let timer = null, area_timer = null;
import {calculatePrice} from "../request"

export default {
  name: "priceApply",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    goods: {
      type: Object
    },
    company_id: String,
    order_id: String,
    contract_template: String
  },
  data() {
    return {
      inputKey: {
        "goods_length": "长度",
        "goods_width": "宽度",
        "weight": "重量"
      },
      handle_goods_show: false,
      is_disabled: false,
      is_init: false,
      current_goods: {},
      input_form: {},
      goods_length: "",
      goods_width: "",
      weight: "",
      pre_goods_length: "",
      pre_goods_width: "",
      pre_weight: "",
      pre_area: "",
      goods_num: "",
      good_unit_price: "",
      new_goods_actual_price: "",
      area: "",
      checkout_obj: {},
      orderGoodsSpecificationInputBeans: []
    }
  },
  watch: {
    //商品数量发生变化
    goods_num(n) {
      if (this.is_init) return;
      if (!this.handle_goods_show && n <= 0) return;
      this.new_goods_actual_price = this.mul(this.good_unit_price, this.mul(this.area, n));
    },
    //商品长度发生变化
    'current_goods.goods_length'(n) {
      if (this.is_init) return;
      if (!this.handle_goods_show || n <= 0) return;
      this.area = this.mul(n, this.mul(this.current_goods.goods_width || 1, this.current_goods.weight || 1));
    },
    //商品宽度发生变化
    'current_goods.goods_width'(n) {
      if (this.is_init) return;
      if (!this.handle_goods_show || n <= 0) return;
      this.area = this.mul(n, this.mul(this.current_goods.goods_length || 1, this.current_goods.weight || 1));
    },
    //商品重量发生变化
    'current_goods.weight'(n) {
      if (this.is_init) return;
      if (!this.handle_goods_show || n <= 0) return;
      this.area = this.mul(n, this.mul(this.current_goods.goods_length || 1, this.current_goods.goods_width || 1));
    },
    //商品面积发生变化
    area(n) {
      if (this.is_init) return;
      if (!this.handle_goods_show && n <= 0) return;
      this.new_goods_actual_price = this.mul(this.good_unit_price, this.mul(this.area, this.goods_num));
      this.checkoutV2();
      this.areaChange();
    },
    //商品单价发生变化
    'good_unit_price'(n) {
      if (this.is_init) return;
      if (this.is_disabled) return;
      if (!this.handle_goods_show && n < 0) return;
      this.new_goods_actual_price = this.toDecimal2(this.mul(n, this.mul(this.area, this.goods_num)));
    },
    //商品总价发生变化
    new_goods_actual_price(n) {
      if (this.is_init) return;
      if (!this.is_disabled) return;
      if (!this.handle_goods_show || Number(this.goods_num) <= 0) return;
      this.good_unit_price = this.toDecimal2(this.div(n, this.mul(this.area, this.goods_num)))

      this.checkoutV2();
    },
    handle_goods_show(n) {
      if (!n) {
        this.$emit('update:show', false)
      }
    },
    goods: {
      deep: true,
      handler(n) {
        this.current_goods = n;
      }
    },
    show(n) {
      this.current_goods = this.$props.goods;
      this.handle_goods_show = n;
      if (n) {
        this.init();
      }
    },
  },
  computed: {
    //跌幅
    decline() {
      let {goods_actual_price} = this.current_goods;
      if (this.is_Empty(goods_actual_price) || this.is_Empty(this.new_goods_actual_price)) return 0;
      let num = this.toDecimal2((this.new_goods_actual_price - goods_actual_price) / goods_actual_price * 100);
      return num > 0 ? 0 : Math.abs(num);
    },
    goodsSpecificationInputList() {
      if (this.is_Empty(this.goods.orderGoodsSpecificationInputBeans)) return [];
      let list = [];
      this.goods.orderGoodsSpecificationInputBeans.forEach(el => {
        let currentRange = this.inputRange[el.input_name];
        let o = {
          label: this.inputKey[el.input_name],
          key: el.input_name,
          min: 0.01,
          max: Infinity
        }
        if (!this.is_Empty(currentRange)) {
          let min = Number(currentRange.min);
          let max = Number(currentRange.max);
          o.min = min === 0 ? 0.01 : min;
          o.max = max === 0 ? Infinity : max;
        }
        list.push(o)
      })
      return list;
    },
    //输入范围限制
    inputRange() {
      if (this.is_Empty(this.$props.goods)) return {};
      if (this.is_Empty(this.$props.goods.input_range)) return {};
      let o = {};
      let input_range = this.$props.goods.input_range;
      input_range = JSON.parse(input_range);
      input_range.forEach(el => {
        o[el.input_name] = el;
      })
      return o;
    },
  },
  created() {
    this.handle_goods_show = this.$props.show;
    this.init();
  },
  methods: {
    enterALimit(i) {
      if (this.is_Empty(i)) return '';
      if (i.min === -Infinity && i.max === Infinity) return "输入无限制";
      if (i.min === -Infinity && i.max !== Infinity) return `输入小于${i.max}`;
      if (i.min !== -Infinity && i.max === Infinity) return `输入大于${i.min}`;
      return `输入在${i.min}到${i.max}之间`;
    },
    areaChange() {
      if (this.is_Empty(this.current_goods)) return;
      if (this.is_Empty(this.current_goods.orderCraftBeans)) return;
      if (this.pre_area === this.area) return;
      if (area_timer != null) {
        clearTimeout(area_timer);
      }
      area_timer = setTimeout(() => {
        this.$confirm('您已修改商品面积，如继续会将工艺信息清除，是否需要修改？', '提示', {
          confirmButtonText: '确定清空',
          cancelButtonText: '取消修改',
          type: 'warning'
        }).then(() => {
          this.$set(this.current_goods, 'orderCraftBeans', []);
        }).catch(() => {
          this.goods_length = this.pre_goods_length
          this.goods_width = this.pre_goods_width
          this.weight = this.pre_weight
        });
      }, 1000);
    },
    init() {
      if (this.is_Empty(this.current_goods)) return;
      this.is_init = true;
      this.pre_goods_length = null
      this.pre_goods_width = null
      this.pre_weight = null
      this.pre_area = null
      let current = JSON.parse(JSON.stringify(this.current_goods));
      this.area = 1;
      let orderGoodsSpecificationInputBeans = [];
      current.orderGoodsSpecificationInputBeans.forEach(el => {
        orderGoodsSpecificationInputBeans.push(el.input_name);
        this.current_goods[el.input_name] = el.input_value
        this[`pre_${el.input_name}`] = el.input_value
        this.area = this.mul(this.area, el.input_value);
      })
      this.new_goods_actual_price = current.goods_actual_price;
      this.pre_area = this.area;
      this.good_unit_price = this.toDecimal2(this.div(current.goods_actual_price, this.mul(this.area, current.goods_num)))
      this.goods_num = current.goods_num;
      this.orderGoodsSpecificationInputBeans = orderGoodsSpecificationInputBeans;
      setTimeout(() => {
        this.is_init = false;
      }, 50)
      this.checkoutV2();
    },
    //计算价格
    checkoutV2() {
      if (this.is_Empty(this.current_goods)) return;
      if (timer != null) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        let current_goods = JSON.parse(JSON.stringify(this.current_goods));
        let orderGoodsSpecificationInputBeans = [];
        this.orderGoodsSpecificationInputBeans.forEach(el => {
          orderGoodsSpecificationInputBeans.push({
            input_name: el,
            input_value: current_goods[el]
          })
        })
        calculatePrice({
          ...current_goods,
          goods_num: this.goods_num,
          company_id: this.$props.company_id,
          orderGoodsSpecificationInputBeans
        }).then(res => {
          this.current_goods.goods_actual_price = res.data.orderGoodsBeans[0].goods_actual_price
          this.current_goods.goods_min_price = res.data.orderGoodsBeans[0].goods_min_price
          this.current_goods.standard_price = res.data.orderGoodsBeans[0].specification_price
          this.current_goods.goods_total_price = res.data.orderGoodsBeans[0].goods_total_price
          this.current_goods.standard_total_price = res.data.orderGoodsBeans[0].order_actual_price
        })
      }, 1000);


    },
    //确认改价,判断改价权限
    async changeOrderGoodsPriceCheck() {
      let goods = this.current_goods;
      let goodsUnitPrice = this.toDecimal2(this.good_unit_price);
      let order_goods_json = {
        order_goods_id: goods.order_goods_id,
        goods_id: goods.goods_id,
        goods_type: goods.goods_type,
        goods_num: this.goods_num,
        goods_actual_price: this.new_goods_actual_price,
        goods_price: goodsUnitPrice,
        specification_price: goodsUnitPrice,
        specification_id: goods.specification_id,
        orderCraftBeans: goods.orderCraftBeans
      }
      let orderGoodsSpecificationInputBeans = [];
      this.orderGoodsSpecificationInputBeans.forEach(el => {
        orderGoodsSpecificationInputBeans.push({
          input_name: el,
          input_value: goods[el]
        })
      })
      order_goods_json.orderGoodsSpecificationInputBeans = orderGoodsSpecificationInputBeans;
      let obj = {
        order_goods_json: JSON.stringify(order_goods_json),
        order_id: this.$props.order_id,
        company_id: this.$props.company_id
      };
      let _this = this;
      let res = await this.post("orderInterfaces/v1.0/changeOrderGoodsPriceCheck", obj)
      this.handle_goods_show = false;
      this.emitFun(res.data);
      return;
      if (Number(res.data) === 0) {
        this.handle_goods_show = false;
        this.$confirm('当前订单已超出改价范围,是否需要发起价格审批?', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning'
        }).then(() => {
          _this.$prompt('请输入价格审批理由', '温馨提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
          }).then(({value}) => {
            _this.applyCompanyGoodsPrice(value);
          }).catch(() => {
          });
        }).catch(() => {
        });
      } else {
        this.handle_goods_show = false;
        this.emitFun();
      }
    },
    //发起价格申请
    applyCompanyGoodsPrice(value) {
      let goods = this.current_goods;
      let goodsUnitPrice = this.toDecimal2(this.good_unit_price);
      let order_goods_json = {
        order_goods_id: goods.order_goods_id,
        goods_id: goods.goods_id,
        goods_type: goods.goods_type,
        goods_num: this.goods_num,
        goods_actual_price: this.new_goods_actual_price,
        goods_price: goodsUnitPrice,
        specification_price: goodsUnitPrice,
        contract_template: this.$props.contract_template,
        dd_apply_remarks: value,
        order_id: this.$props.order_id,
        company_id: this.$props.company_id,
        order_goods_craft_json: JSON.stringify(goods.orderCraftBeans),
        craft_remark: goods.craft_remark,
        specification_id: goods.specification_id,
        specification_unit: goods.specification_unit,
        price_unit: goods.price_unit,
        other_order_goods: goods.other_order_goods_json,
      }
      let orderGoodsSpecificationInputBeans = [];
      this.orderGoodsSpecificationInputBeans.forEach(el => {
        orderGoodsSpecificationInputBeans.push({
          input_name: el,
          input_value: goods[el]
        })
      })
      order_goods_json.order_goods_specification_json = JSON.stringify(orderGoodsSpecificationInputBeans);
      this.post("orderSalePriceApplication/v1.0/apply", order_goods_json).then(res => {
        this.$message.success("已发起审批,请等待审批");
        this.handle_goods_show = false;
        this.emitFun()
      })
    },
    emitFun(data) {
      let current = JSON.parse(JSON.stringify(this.current_goods));
      let goodsUnitPrice = this.toDecimal2(this.good_unit_price);
      current.goods_num = this.goods_num;
      current.goods_price = goodsUnitPrice;
      current.specification_price = goodsUnitPrice;
      current.goods_actual_price = this.toDecimal2(this.new_goods_actual_price)
      current.is_apply_goods_price = Number(data) === 0;
      current.fall_percent = this.decline;
      let orderGoodsSpecificationInputBeans = [];
      this.goodsSpecificationInputList.forEach(el => {
        orderGoodsSpecificationInputBeans.push({
          input_name: el.key,
          input_value: current[el.key]
        })
      })
      current.orderGoodsSpecificationInputBeans = orderGoodsSpecificationInputBeans;

      this.$emit('success', current)
    },
  }
}
</script>

<style lang="scss">
.price-apply {
  .el-input {
    width: 100%;
  }

  .el-form-item {
    margin-bottom: 10px;
  }

  .el-form--label-top .el-form-item__label {
    padding-bottom: 0;
  }

  .computed-price-type1 {
    display: grid;
    grid-template-columns: 30% 5% 30% 5% 30%;
    line-height: 40px;

    span {
      text-align: center;
    }
  }

  .computed-price-type2 {
    display: grid;
    grid-template-columns: 45% 10% 45%;
    line-height: 40px;

    span {
      text-align: center;
    }
  }

  .dialog {
    .el-dialog__body {
      padding: 20px;


    }

  }
}
</style>


// WEBPACK FOOTER //
// src/page/me/salesOrder/component/priceApply.vue